<template>
  <v-main>
      <!-- <v-container>
        <v-row>
          <v-col
            v-for="tab in tabs"
            :key="tab.title"
            cols="12"
            xs="12"
            sm="6"
            md="4"
            outlined
            class="rounded-xl"
          >
            <v-card class="mx-auto" outlined shaped max-width="350" color="secondary" dark router :to="tab.url">
              <v-card-text>
                <v-row justify="space-around">
                  <v-icon x-large color="red darken-3">{{ tab.icon }}</v-icon>
                </v-row>

              </v-card-text>
              <v-card-subtitle>
                <div
                  class="text--primary text-center text-h5"
                  v-text="tab.title"
                ></div>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-container> -->
    </v-main>
</template>

<script>
export default {
  data: () => ({
    tabs: [
      {
        title: "Account Profiles",
        url: "profiles",
        icon: "mdi-account-box"
      },
    ],
  }),
  created() {
    
    this.$router.push({name: "Profiles"})
  }
};
</script>
